import moment from 'moment-timezone';
import {environment} from "environments";

(() => {
  class AppointmentsTableController {
    constructor() {
      this.BOD_1780 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV)
    }

    formatDate(iso_date) {
      if (!iso_date) return null;
      let formatted_date = moment.tz(iso_date, this.timezone).format('DD/MMM/YY h:mm A');
      // console.log("formatDate:",iso_date,this.timezone,formatted_date);
      return formatted_date;
    }

    getAppointmentDateClass(time) {
      let now = new Date().getTime(); // millisenconds

      let appointment_time = new Date(time).getTime(); // millisenconds

      if (now >= appointment_time + 60000) return 'color-red-status';
      return 'system-code-color-PD';
    }

  }

  angular.module('pims').component('appointmentsTable', {
    templateUrl: 'app/components/appointments-table/appointments-table.html',
    controller: AppointmentsTableController,
    bindings: {
      pagination: '=',
      sortBy: '=',
      sortOrder: '=',
      onPageChange: '&',
      onSort: '&',
      visits: '<',
      profile: '<',
      timezone: '='
    }
  });
})();
